export default __webpack_public_path__ + "static/media/7minfitness@3x.bb47003e.jpg";